// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#msdoc-renderer{overflow:hidden !important}`, "",{"version":3,"sources":["webpack://./src/brands/dentistry-one/Dashboard/ConsultationPage/CollapsibleSections/ImagesSection/styles.css"],"names":[],"mappings":"AAAA,gBACE,0BAAA","sourcesContent":["#msdoc-renderer {\n  overflow: hidden !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
